import React from 'react';
import RegisterForm from '../../components/RegisterForm';

function MemberView({
    events,
    selectedEvent,
    selectedEventId,
    setSelectedEventId,
    selectedRegistration,
    onRegistrationSuccess
}) {
    return (
        <>
            {events.length > 0 && (
                <div className="action-row" style={{ marginBottom: '1rem' }}>
                    <div className="cta-text" style={{ width: '100%' }}>
                        <p>Select Event</p>
                        <select
                            value={selectedEventId || selectedEvent?._id || ''}
                            onChange={(e) => setSelectedEventId(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '0.8rem',
                                background: '#111',
                                color: '#fff',
                                border: '1px solid #333'
                            }}
                        >
                            {events.map((event) => (
                                <option key={event._id} value={event._id}>
                                    {event.title}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            )}

            <RegisterForm
                event={selectedEvent}
                existingRegistration={selectedRegistration}
                onSignupSuccess={onRegistrationSuccess}
            />
        </>
    );
}

export default MemberView;